import { Hand, Award, Users, Plane } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { scrollToSection } from "./constants";

const SERVICES = [
  {
    icon: Hand,
    title: "In-Hand & Groundwork Training",
    body: "Youngster backing, groundwork, behaviour and confidence — calm, correct foundations built from the ground up.",
  },
  {
    icon: Award,
    title: "Under-Saddle Horse Training",
    body: "Schooling, exercise and the refinement of higher-level dressage work — from green horses to the collected movements.",
  },
  {
    icon: Users,
    title: "Horse & Rider Coaching",
    body: "Private one-on-one lessons, tailored from first-time beginners to advanced riders, at your own stables.",
  },
  {
    icon: Plane,
    title: "Vacation Care & Exercise",
    body: "Peace-of-mind training and full exercise packages while you travel. Your horse's routine — and progress — uninterrupted.",
  },
];

const Services = () => (
  <section id="services" data-testid="services-section" className="bg-charcoal py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <div>
          <Reveal>
            <Chapter number="03" title="The Disciplines" testId="services-chapter" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-8 max-w-lg font-serif text-4xl font-light leading-tight tracking-tight text-offwhite md:text-5xl">
              Four ways to a{" "}
              <em className="italic text-gold">better horse.</em>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-sm text-sm font-light leading-relaxed text-cream/55">
            Every programme is built around the individual horse — its body,
            its mind, its history — and its owner's ambitions for the season.
          </p>
        </Reveal>
      </div>

      <div className="mt-20 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
        {SERVICES.map((s, i) => (
          <Reveal key={i} delay={0.1 + i * 0.1} className={i % 2 === 1 ? "xl:mt-14" : ""}>
            <div
              data-testid={`service-card-${i + 1}`}
              onClick={() => scrollToSection("#consultation")}
              className="group relative h-full cursor-pointer border border-champagne/20 bg-ebony/60 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.35)] backdrop-blur-2xl transition-colors duration-500 hover:border-gold/60 lg:p-9"
            >
              <span className="absolute right-6 top-5 font-serif text-6xl font-light italic text-cream/[0.06] transition-colors duration-500 group-hover:text-gold/15">
                0{i + 1}
              </span>
              <s.icon
                className="text-gold transition-transform duration-500 group-hover:-translate-y-1"
                size={26}
                strokeWidth={1.25}
              />
              <h3 className="mt-8 font-serif text-2xl font-normal leading-snug text-offwhite">
                {s.title}
              </h3>
              <p className="mt-4 text-sm font-light leading-relaxed text-cream/55">
                {s.body}
              </p>
              <div className="mt-8 h-px w-10 bg-champagne/40 transition-all duration-700 group-hover:w-full group-hover:bg-gold/60" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
